import { render, staticRenderFns } from "./VideoAnalysisBreakdown.vue?vue&type=template&id=09afbf5e&scoped=true"
import script from "./VideoAnalysisBreakdown.vue?vue&type=script&lang=js"
export * from "./VideoAnalysisBreakdown.vue?vue&type=script&lang=js"
import style0 from "./VideoAnalysisBreakdown.vue?vue&type=style&index=0&id=09afbf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09afbf5e",
  null
  
)

export default component.exports